/**
 * Estado TEMPORÁRIO (só no browser, sessionStorage) da tela "Síntomas del niño"
 * enquanto o usuário navega no wizard. NÃO vai para o Firebase — os sintomas são
 * gravados normalmente em childCase.symptoms/anotherDisease/comments no "Próximo".
 * Diferente das vacinas, sintomas NÃO são carregados numa próxima visita (o
 * paciente pode não ter sintomas), então o rascunho é apenas para a ida-volta.
 * Limpo ao concluir/cancelar o caso (ChildCaseService.cancelCaseRegistry).
 */
export interface SymptomsDraft {
    selected?: string[];
    hasAnotherDisease?: boolean;
    anotherDisease?: string | null;
    comments?: string | null;
}

export class SymptomsDraftUtil {
    private static readonly PREFIX = 'nm-symptoms-draft:';

    private static key(token: string): string {
        return SymptomsDraftUtil.PREFIX + (token || 'anon');
    }

    static save(token: string, draft: SymptomsDraft): void {
        try {
            sessionStorage.setItem(SymptomsDraftUtil.key(token), JSON.stringify(draft));
        } catch {
        }
    }

    static load(token: string): SymptomsDraft | null {
        try {
            const raw = sessionStorage.getItem(SymptomsDraftUtil.key(token));
            return raw ? JSON.parse(raw) as SymptomsDraft : null;
        } catch {
            return null;
        }
    }

    static clear(token: string): void {
        try {
            sessionStorage.removeItem(SymptomsDraftUtil.key(token));
        } catch {
        }
    }
}
